import assetPath from '/app/xinglets/network/entry-logged-out/src/components/discover-network/assets/network-image-small-en.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')